// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_PayResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_PayResponse — result of POST /subscriptions/pay (the grace
 * payment door).
 *
 * Carries the checkout URL of the charge the franchise must settle, plus the
 * money the payer is about to be asked for, so the caller can show it before
 * sending anyone to a payment page.
 *
 * NOTE — there is deliberately NO `success` field in here (contrast
 * Subscriptions_SubscribeResponse, which has one). sendResponse() always emits
 * `{success: true, …}` and sendError() emits `{success: false, …}` — both at
 * HTTP 200 — so a `dados.success` invites the exact bug class documented in
 * skill billing-staff-console §4: a refusal read as a celebration. Refusals on
 * this endpoint go out through sendError() ONLY, and the client must read the
 * ENVELOPE's success.
 *
 * PCI note: no card/cartao/cvv/pan/token field may ever be added here.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Subscriptions_PayResponseDados {
checkout_url: string
subscription_id: number
amount_cents: number
currency: string
reused: boolean
}

export type Subscriptions_PayResponse = ApiResponse<Subscriptions_PayResponseDados>;

registerResponseContract('Subscriptions_PayResponse', {
  checkout_url:    { type: 'string',  required: true },
  subscription_id: { type: 'number',  required: true },
  amount_cents:    { type: 'number',  required: true },
  currency:        { type: 'string',  required: true },
  reused:          { type: 'boolean', required: true },
})
